import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpProfile.css";

export default function Helprto() {
  const { t } = useTranslation("help");

  const rowsData = t("helprto.table.rows", {
    returnObjects: true,
    defaultValue: {
      id: {
        column: "id",
        type: "string",
        meaning: "Unique tracking identifier for each RTO case.",
        guidance: "Use stable IDs for latency regression comparison."
      },
      prompt: {
        column: "Prompt",
        type: "string",
        meaning: "Raw adversarial payload injected during red-team evaluation.",
        guidance:
          "Include prompts expected to trigger slow reasoning, long responses, policy conflict, tool calls, or known performance-heavy paths."
      },
      category: {
        column: "Category",
        type: "string enum",
        meaning: "Primary RTO threat category.",
        guidance:
          "Use behavioural_threats, malicious_data_insertion, or input_output_risks."
      },
      subCategory: {
        column: "SubCategory",
        type: "string enum",
        meaning: "Specific vulnerability or exploitation vector.",
        guidance:
          "Examples include jailbreak, model_drifts, multi_step_malicious_intent, and indirect_prompt_injections."
      },
      severity: {
        column: "Severity",
        type: "string enum",
        meaning: "Risk tier for the case.",
        guidance: "Use severity to prioritize slow plus unsafe cases in reports."
      },
      expectedResults: {
        column: "ExpectedResults",
        type: "regex string",
        meaning: "Pattern used to detect compromised output.",
        guidance:
          "Use a regex that catches roleplay assertions, leaks, prohibited terms, or other failure signatures."
      }
    }
  });

  const tableRows = Array.isArray(rowsData)
    ? rowsData
    : Object.values(rowsData || {});

  return (
    <div className="theme-whbl">
      {/* Header */}

      <div className="container-fluid">
        <div className="row">
          <main>
            <div className="dashboard">
              {/* Page Header */}
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">
                    {t(
                      "helprto.title",
                      "Response Time Optimization Input Format"
                    )}
                  </h1>
                </div>
              </div>

              <img
                className="help-img"
                  src={t("helprto.image")}
                alt="Attack Surface Tests Status"
              />
<br/><br/>

               <img
                className="help-img"
                  src={t("helprto.image2")}
                alt="Attack Surface Tests Status"
              />
<br/><br/>

               <img
                className="help-img"
                  src={t("helprto.image3")}
                alt="Attack Surface Tests Status"
              />

              {/* Step 1 */}
              <div>
                <p>
                  {t(
                    "helprto.description",
                    "RTO profiles use a CSV format similar to prompt-safety tests, but the prompt is treated as an adversarial or performance-relevant red-team payload. The profile measures how the endpoint responds and can connect latency with safety or output-pattern results."
                  )}
                </p>

                <div>
                  <table className="dark-guide-table">
                    <thead>
                      <tr>
                        <th>
                          {t("helprto.table.headers.column", "Column")}
                        </th>
                        <th>
                          {t("helprto.table.headers.type", "Type")}
                        </th>
                        <th>
                          {t("helprto.table.headers.meaning", "Meaning")}
                        </th>
                        <th>
                          {t("helprto.table.headers.guidance", "RTO-specific guidance")}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {tableRows.map((row, index) => (
                        <tr key={index}>
                          <td>{row.column}</td>
                          <td>{row.type}</td>
                          <td>{row.meaning}</td>
                          <td>{row.guidance}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <style>{`
                  .dark-table-container {
                    width: 100%;
                    margin: 20px 0;
                    overflow-x: auto;
                    background: #111827;
                    padding: 0;
                    box-sizing: border-box;
                  }

                  .dark-guide-table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    font-family: "Segoe UI", Arial, sans-serif;
                    font-size: 14px;
                    color: #e5e7eb;
                    background: #111827;
                    border: 1px solid #374151;
                  }

                  /* Header */
                  .dark-guide-table thead th {
                    background: #1f2937;
                    color: #60a5fa;
                    font-weight: 700;
                    text-align: left;
                    padding: 12px 14px;
                    border: 1px solid #4b5563;
                    vertical-align: middle;
                  }

                  /* Body cells */
                  .dark-guide-table tbody td {
                    background: #111827;
                    color: #e5e7eb;
                    padding: 12px 14px;
                    border: 1px solid #374151;
                    vertical-align: top;
                    line-height: 1.55;
                  }

                  /* Slight alternate row */
                  .dark-guide-table tbody tr:nth-child(even) td {
                    background: #172033;
                  }

                  /* Hover */
                  .dark-guide-table tbody tr:hover td {
                    background: #1e293b;
                  }

                  /* Column widths */
                  .dark-guide-table th:nth-child(1),
                  .dark-guide-table td:nth-child(1) {
                    width: 18%;
                  }

                  .dark-guide-table th:nth-child(2),
                  .dark-guide-table td:nth-child(2) {
                    width: 15%;
                  }

                  .dark-guide-table th:nth-child(3),
                  .dark-guide-table td:nth-child(3) {
                    width: 32%;
                  }

                  .dark-guide-table th:nth-child(4),
                  .dark-guide-table td:nth-child(4) {
                    width: 35%;
                  }

                  /* Mobile */
                  @media (max-width: 768px) {
                    .dark-table-container {
                      overflow-x: auto;
                    }

                    .dark-guide-table {
                      min-width: 750px;
                    }
                  }
                `}</style>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}